// extracted by mini-css-extract-plugin
export default {"spanBlock":"SuperEditableSpan_spanBlock__qSOcQ","span":"SuperEditableSpan_span__zauwT","input":"SuperEditableSpan_input__z0xCQ","pen":"SuperEditableSpan_pen__tP2Kx"};